jQuery(document).ready(function ($) {

	const { createApp } = Vue
	const app = createApp({
		data: () => {
			return {
				userName: sessionStorage.email ? sessionStorage.email.replace("#", "@").split('').reverse().join('') : "",
				password: "",
				loading: true,
				domain: window.location.hostname,
				user_select: 'login',
				show_login: true,
				stay_connected: false,
				show_stay_button: false,
				show_password: false,
				show_error_message: true,
				show_recover_message: false,
				cookies: {
					cname: "secure_customer_sig",
					samesite: "lax",
				},
				password_err: false,
				login_err: false,
			}
		},
		mounted: function () {
			var referrer = document.referrer;
			//check il there is an error from shopify
			const hasError = document.getElementsByClassName("form-invalid-datas")
			if (hasError.length) {
				this.password_err = true
				this.login_err = true
				for (index = 0; index < hasError.length; index++) hasError[index].classList.remove("form-invalid-datas")

			}
			//remove hidden classes

			document.getElementById("RecoverPasswordForm").classList.remove("hidden")

			const errorsContainer = document.getElementsByClassName("field-error-container")
			for (index = 0; index < errorsContainer.length; index++) errorsContainer[index].classList.remove("hidden")

			q = this.get_url_vars();
			if (q.show) {
				this.show_login = false;
			} else {
				this.show_login = true;
			}

			//check if there is #recover in the url and hide the form if so
			const pwdRecoveredList = document.getElementsByClassName("password-recovered");
			const urlHash = window.location.hash;
			if (urlHash.includes("recover") || pwdRecoveredList.length) {
				// this.show_login = false
				this.show_error_message = false
				$('#ResetSuccess').removeClass('hidden');
				window.history.replaceState(null, "", "login")
				if (pwdRecoveredList.length) {
					pwdRecoveredList[0].classList.remove("password-recovered")
				}
			}

			//prepopulate email field with a session variable
			if (sessionStorage.email) {
				$('#CustomerEmail').val(sessionStorage.email.replace("#", "@").split('').reverse().join(''))
				sessionStorage.removeItem("email");
			}

			/**
			 * add link guest
			 */
			var url = $('#customer_login_guest input[name="checkout_url"] ').val();
			if (url) {
				$('.icon-arrow-back-account').attr('href', url);
			}
			/**
			 * check if url have orderslits=true and add show=comandes to form url
			 */
			if (q['order-history']) {
				//$('#customer_login').attr('action', '/account/login?show=commande');
				Cookies.set('test', 1);
			} else {
				Cookies.set('show_commandes', 0);
			}
		},
		methods: {
			submitForm(event) {
				let error = false
				if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.userName) == false) {
					error = true;
					this.login_err = true
				}
				if (this.password.length < 5) {
					error = true;
					this.password_err = true
				}
				if (error) {
					event.preventDefault()
				}
				else {
					//save email in a session storage in case  the register fail
					sessionStorage.setItem("email", this.userName.replace("@", "#").split('').reverse().join(''))
				}
			},
			submitRecover(event) {
				if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.userName) == false) {
					event.preventDefault()
					this.login_err = true;
				}
				else {
					sessionStorage.setItem("email", this.userName.replace("@", "#").split('').reverse().join(''))
				}
			},
			switch_cookie(state) {
				//generating expired date in UTC format(1 year from the moment the cookie is supposed to be enabled)
				var expDate = new Date().toUTCString();
				var test = expDate;
				expDate = expDate.substring(0, 3) + expDate.substring(4, expDate.length);
				year = Number(expDate.substring(11, 15)) + 1;
				expDate = expDate.substring(0, 11) + year + expDate.substring(15, expDate.length);

				//setting the value of the cookie (nothing or one day)
				val = state ? "1j" : "";

				//settings the cookie cookie_name = val; expires = expired date; path = /; domain = current domain
				// cookie_string = this.cookies.cname + " = " + val + "; domain = test.com; expires=" + expDate + "; path =/; domain = " + this.domain + "; samesite=" + this.cookies.samesite;
				// document.cookie = cookie_string;
				// console.log("cookie: " + cookie_string);

				// cookie = Cookies.get(this.cookies.cname);
				Cookies.remove(this.cookies.cname);
				Cookies.set(this.cookies.cname, val, { path: "/", expires: 365, domain: this.domain, secure: true, samesite: this.cookies.samesite });
				// console.log("cookie name ", Cookies.set({}));
			},
			select_page: function () {
				// console.log(this.user_select);
				if (this.user_select == 'register') { location.href = "/account/register"; }
			},
			get_url_vars: function () {
				var vars = [], hash;
				var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
				for (var i = 0; i < hashes.length; i++) {
					hash = hashes[i].split('=');
					vars.push(hash[0]);
					vars[hash[0]] = hash[1];
				}
				return vars;
			},
			show_or_hide: function (e) {
				e.preventDefault();
				if (this.show_login) {
					this.show_login = false;
					this.userName = "";
					this.password = "";

				} else {
					this.show_login = true;
					this.userName = "";
				}
				this.login_err = false;
				this.password_err = false;
			}
		},
	});
	app.config.compilerOptions.delimiters = ['${', '}'];
	app.unmount();
	app.mount('#app_page_user');
});